const dotJoin = parts =>
  parts
    .map(p => (typeof p === 'string' ? p.trim() : p))
    .filter(Boolean)
    .join(' · ');

export const formatInsuranceOrderLine1 = item => {
  const dose =
    item?.dosageQuantity != null && item?.dosageUnitName
      ? `${item.dosageQuantity} ${item.dosageUnitName}`.trim()
      : '';
  const freq = item?.frequencyName?.trim() || '';
  const duration =
    item?.duration != null && item?.durationUnitName
      ? `${item.duration} ${item.durationUnitName}`.trim()
      : '';
  return dotJoin([dose, freq, duration]);
};

export const formatInsuranceOrderLine2 = item => {
  const times = (item?.timesOfDay || [])
    .map(t => (t?.name && String(t.name).trim() ? t.name.trim() : null))
    .filter(Boolean);
  const timePart = times.length ? times.join(', ') : '';
  const instruction = item?.instructionName?.trim() || '';
  return dotJoin([timePart, instruction]);
};
